import router from '@/router'
import store from '@/store'
import get from 'lodash/get'
import isEqual from 'lodash/isEqual'
import findIndex from 'lodash/findIndex'
import axios from '@/lib/axios'
import { parse, format } from 'date-fns/esm'

export function randomValue(arr) {
  return arr[Math.floor(Math.random() * arr.length)]
}

export function randomNumber(max) {
  return Math.floor(Math.random() * max) + 1
}

export function randomBool() {
  return randomValue([true, false])
}

export function joinArraySentence(arr) {
  if (arr.length <= 2) {
    return arr.join(' and ')
  } else {
    return arr.reduce((acc, val, idx) => {
      return idx === arr.length - 1 ? `${acc}, and ${val}` : `${acc}, ${val}`
    })
  }
}

export function titleCase(str = '') {
  return str
    .replaceAll('_', ' ')
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ')
}

export function toggle(array, item) {
  if (array.includes(item)) array.splice(array.indexOf(item), 1)
  else array.push(item)
  return array
}

const errMessages = {
  'User account already exists':
    'User name already exists. User name must be unique.',
}

export function translateError(msg) {
  return errMessages[msg] || msg
}

export function refreshError(err) {
  window.localStorage.setItem('refreshError', JSON.stringify(err))
}

export function extractMessage(err) {
  return get(err, 'response.data.message') || err.message
}

export function globalError(err, message = null) {
  store.dispatch('setGlobalNotification', {
    message: message || extractMessage(err),
    type: 'danger',
  })
}

export function globalSuccess(err, message = null) {
  store.dispatch('setGlobalNotification', {
    message:
      message ||
      get(err, 'response.data.message') ||
      get(err, 'data.message') ||
      err.message,
    type: 'success',
  })
}

// This function looks for an object in an array by testing object value equality.
export function isIn(arr, obj) {
  return findIndex(arr, o => isEqual(obj, o)) >= 0
}

const idTypeCodes = {
  ALIEN: 'Alien Registration Card',
  INSTITUTION: 'Educational/Institutional Issued',
  PASSPORT: 'Passport',
  OTHER: 'Other ID',
  MILITARY_ID: 'Military ID',
  STATE_ID: 'State-Issued ID',
  DL_ID: "Driver's License ID",
}

export function idType(code) {
  return idTypeCodes[code]
}

export function parseDbDt(dt) {
  return parse(dt, 'MM/dd/yyyy', new Date())
}

export function formatDtOnly(dt) {
  return format(dt, 'MM/dd/yyyy')
}

export function jwtPayload(token) {
  let t = token
    .split('.')[1]
    .replace(/_/g, '/')
    .replace(/-/g, '+')
  return JSON.parse(window.atob(t))
}

export function epochTime() {
  return Math.floor(new Date().getTime() / 1000)
}

export function waitReport(reportId, forwardUrl) {
  store.commit('incLoader')
  let intrv
  let startTime = new Date().getTime()
  let forwardTo =
    typeof forwardUrl === 'string'
      ? forwardUrl.replace('%id%', reportId)
      : forwardUrl
  intrv = window.setInterval(() => {
    let currentTime = new Date().getTime()
    if (currentTime - startTime >= 45000) {
      store.commit('decLoader')
      router.push({ name: 'my_reports' })
      globalSuccess(
        null,
        'This report is taking longer than expected. Please check My Reports periodically until it is complete.',
      )
      clearInterval(intrv)
    }
    axios()
      .get('/api/reports/status', {
        params: { id: reportId },
      })
      .then(resp => {
        let status = resp.data.reportStatus
        if (status === 'complete') {
          store.commit('decLoader')
          router.push(forwardTo)
          clearInterval(intrv)
        }
        if (status === 'error') {
          store.commit('decLoader')
          router.push({ name: 'my_reports' })
          globalError(null, 'There was an error with that report.')
          clearInterval(intrv)
        }
      })
      .catch(err => {
        store.commit('decLoader')
        globalError(null, 'There was an error with that report.')
        clearInterval(intrv)
      })
  }, 1000)
}

export function removeDuplicationFromArrays(varWithDupes) {
  return Array.from(new Set(varWithDupes))
}
